// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const StrongboxIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Strongbox/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.042 10.483v1.65a1.042 1.042 0 0 1-2.084 0v-1.65c-.3-.183-.533-.45-.7-.766H2.5a.836.836 0 0 0-.833.833v2.942a4.84 4.84 0 0 0 4.841 4.841h6.975a4.842 4.842 0 0 0 4.85-4.841V10.55a.836.836 0 0 0-.833-.833h-5.758c-.167.316-.4.583-.7.766ZM13.492 1.667H6.508a4.84 4.84 0 0 0-4.841 4.841v1.125c0 .459.375.834.833.834h5.558A1.976 1.976 0 0 1 10.533 6.9a1.965 1.965 0 0 1 1.384 1.383c.016.059.016.125.025.184H17.5a.836.836 0 0 0 .833-.834V6.508a4.84 4.84 0 0 0-4.841-4.841Z"
}));
export default StrongboxIcon;